export default __webpack_public_path__ + "static/media/twitter.2da05f09.svg";